import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { VendorInformationComponent } from "../components/vendor-collect-details/vendor-information/vendor-information.component";
import { Observable } from "rxjs";
import { HomePageService } from "src/app/Customer/services/home-page.service";
@Injectable({ providedIn: 'root' })
export class vendorGuard  {
  private homePageService = inject(HomePageService);

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<VendorInformationComponent> | VendorInformationComponent {
    return this.homePageService.fetchVendor(route.queryParamMap.get('Vendor'));
  }
}